import "@fontsource-variable/ibm-plex-sans"
import "@fontsource/ibm-plex-mono/400.css"
import "@fontsource/ibm-plex-mono/500.css"
import "@fontsource/ibm-plex-mono/600.css"
import "@app/ui/theme.css"
import "@app/ui/styles.css"
import "flag-icons/css/flag-icons.min.css"
import { ThemeProvider } from "@app/ui"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { RouterProvider } from "@tanstack/react-router"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { router } from "./router"
import { ScopeProvider } from "./scope/scope-context"

const queryClient = new QueryClient()

const rootEl = document.getElementById("root")
if (!rootEl) {
	throw new Error("Root element #root not found in index.html")
}

createRoot(rootEl).render(
	<StrictMode>
		<ThemeProvider defaultTheme="light">
			<QueryClientProvider client={queryClient}>
				<ScopeProvider>
					<RouterProvider router={router} />
				</ScopeProvider>
			</QueryClientProvider>
		</ThemeProvider>
	</StrictMode>,
)
